import type { DashboardTasks } from '@felix/domain';
import { useTranslation } from 'react-i18next';
import classes from './TasksPanel.module.css';
import { TaskGroupView } from './task-view.js';

/**
 * Zilin iş listesi (ADR 0156 "Zil"): panodaki grupların aynısı, sıkı biçimde; grup başına en çok
 * üç satır. Uyarılar zilde bu listenin altında `AlertList` ile durur.
 */
export function TaskBellList({ tasks }: { tasks: DashboardTasks }) {
  const { t } = useTranslation();
  if (tasks.groups.length === 0) return null;
  return (
    <section className={classes.bell} aria-label={t('tasks.heading')}>
      {tasks.partial ? (
        <p className={classes.partial} role="status">
          {t('tasks.partial')}
        </p>
      ) : null}
      {tasks.groups.map((group) => (
        <TaskGroupView key={group.kind} group={group} compact />
      ))}
    </section>
  );
}
